// AMEvents uses ONLY US Based Timezones Currently, and displays only 3(4) letter versions of their "Standard Time"
export const usTimezones = {
  'Atlantic Time': 'America/Puerto_Rico',
  'Eastern Time': 'America/New_York',
  'Central Time': 'America/Chicago',
  'Mountain Time': 'America/Denver',
  'Pacific Time': 'America/Los_Angeles',
  'Alaska Time': 'US/Alaska',
  'Hawaii-Aleutian Time': 'Pacific/Honolulu',
};

export const timezonesAbbrMap = {
  AST: 'America/Puerto_Rico',
  EST: 'America/New_York',
  CST: 'America/Chicago',
  MST: 'America/Denver',
  PST: 'America/Los_Angeles',
  AKST: 'US/Alaska',
  HST: 'Pacific/Honolulu',
};

export function getUsTimezoneOptions() {
  return Object.keys(usTimezones).map((key) => ({
    id: `${key}, in other words ${usTimezones[key]}`,
    text: `${key} (i.e. ${usTimezones[key]})`,
    value: usTimezones[key],
  }));
}

export function getUserTimezone() {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (Object.values(usTimezones).includes(userTimeZone)) return userTimeZone;
  return 'America/New_York';
}

export function amToUsTimezone(timezone) {
  let usTimezone = getUserTimezone();
  if (timezone && Object.values(usTimezones).includes(timezone)) {
    usTimezone = timezone;
  } else if (timezone && timezonesAbbrMap[timezone]) {
    usTimezone = timezonesAbbrMap[timezone];
  }
  return usTimezone;
}

export function getTimeUTC(date, useLocalDate = false) {
  return date && date.getTime && (useLocalDate ?
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) :
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}

export function getTimeLocal(millis) {
  return millis && new Date(millis).getTime() + new Date(millis).getTimezoneOffset() * 60000;
}

export default getUsTimezoneOptions;
